import Vue from 'vue'
import router from './router';
import scripts from './theme-scripts';

Vue.config.productionTip = false;

const loadScripts = () => {
    scripts.reduce((promise, url) => {
        return promise.then(() => {
            const script = document.createElement('script');

            script.async = false;
            script.src = url;

            return document.head.appendChild(script);
        });
    }, Promise.resolve());
};

new Vue({
    router,
    updated() {
        loadScripts();
    }
}).$mount('#app');
